import React from 'react';
import ReactDOM from 'react-dom';
import './index.css'; // You can create this file if you need global styles
import App from './App';

document.title = 'FreeSportBroadcasts'; // Set your desired title here

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
